/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import styles from './TabCallPass.module.scss';
import {BaechaList2TableItem, CallPassItem} from "../../../BaechaList2.interface";
import {Table, TableColumnsType, Tag} from "antd";
import {formatKorDate} from "../../../../../util/date";
import dayjs from "dayjs";
import {CheckOutlined, CloseOutlined} from "@ant-design/icons";
import {getScheduleStr} from "../../../../../util/format";
import {onOpenMapByCoordinates} from "../../../BaechaList2Util";

const onClickCell = (e: any, callPassItem: CallPassItem) => {
	e.stopPropagation();

	const { callRegionLatitude, callRegionLongitude } = callPassItem;
	if (callRegionLatitude && callRegionLongitude) {
		onOpenMapByCoordinates({
			lat: callRegionLatitude,
			lon: callRegionLongitude,
		});
	}
};

interface TabCallPassProps {
	data?: BaechaList2TableItem;
}

const TabCallPass = ({ data }: TabCallPassProps) => {
	console.log(data?.callPassItemList);

	const onClickCallDistance = (e: any, callPassItem: CallPassItem) => {
		e.stopPropagation();
		onOpenMapByCoordinates({
			lon: callPassItem?.callRegionLongitude,
			lat: callPassItem?.callRegionLatitude,
		});
	};

	const onClickMemberSettingDistance = (e: any, callPassItem: CallPassItem) => {
		e.stopPropagation();
		onOpenMapByCoordinates({
			lat: callPassItem.memberSettingLatitude,
			lon: callPassItem.memberSettingLongitude,
		});
	};

	const columns: TableColumnsType<CallPassItem> = [
		{
			title: '콜/패스',
			key: 'callPassType',
			width: 80,
			align: 'center',
			onCell: (record: CallPassItem) => ({
				onClick: (e) => onClickCell(e, record),
				style: { cursor: (record.callRegionLatitude && record.callRegionLongitude) ? 'pointer' : '' },
			}),
			render: (value: any, record: CallPassItem, index: number) => record.callPassType === 'call'
				? <Tag color="blue" onClick={(e) => onClickCell(e, record)}>콜</Tag>
				: <Tag color="red" onClick={(e) => onClickCell(e, record)}>패스</Tag>
		},
		{
			title: '거리',
			dataIndex: 'distance',
			key: 'distance',
			width: 40,
			align: 'center',
			render: (item, record) => {
				return (item ? (
					<div
						onClick={(e) => onClickCallDistance(e, record)}
						style={{ cursor: 'pointer' }}
					>
						{`${item.toFixed(1)}km`}
					</div>
				) : null)
			},
		},
		{
			title: '활동지',
			key: 'memberSettingGeoInfo',
			width: 200,
			align: 'center',
			render: (item, record) => {
				if (record.memberSettingDistance && record.memberSettingLocation) {
					return (
						<div
							onClick={(e) => onClickMemberSettingDistance(e, record)}
							style={{ cursor: 'pointer' }}
						>
							{`${record.memberSettingDistance.toFixed(1)}km ${record.memberSettingLocation}`}
						</div>
					)
				}
				return null;
			},
		},
		{
			title: '멤버 순위',
			dataIndex: 'memberRank',
			key: 'memberRank',
			width: 70,
			align: 'center',
		},
		{
			title: '차량 순위',
			dataIndex: 'carTypeRank',
			key: 'carTypeRank',
			width: 70,
			align: 'center',
		},
		{
			title: '시간',
			dataIndex: 'createDate',
			key: 'createDate',
			width: 20,
			align: 'center',
			render: (text: string) => (
				<div style={{ fontVariantNumeric: 'tabular-nums' }}>
					{dayjs(text).format('HH:mm:ss')}
				</div>
			)
		},
		{
			title: '이름',
			dataIndex: 'userName',
			key: 'userName',
			width: 70,
			align: 'center',
		},
		{
			title: '멤버',
			dataIndex: 'memberNickname',
			key: 'memberNickname',
			width: 70,
			align: 'center',
		},
		{
			title: '전화번호',
			dataIndex: 'userPhoneNum',
			key: 'userPhoneNum',
			width: 10,
			align: 'center',
		},
		{
			title: '콜 당시 점수',
			dataIndex: 'point',
			key: 'point',
			width: 90,
			align: 'center',
			render: (text) => text,
		},
		{
			title: '차량',
			dataIndex: 'carType',
			key: 'carType',
			width: 50,
			align: 'center',
		},
		// {
		// 	title: (
		// 		<>
		// 			<div>차량</div>
		// 			<div>번호</div>
		// 		</>
		// 	),
		// 	dataIndex: 'carNumber',
		// 	key: 'carNumber',
		// 	width: 10,
		// 	align: 'center',
		// },
		{
			title: (
				<>
					<div>전월</div>
					<div>미수주</div>
				</>
			),
			key: 'isBenefit',
			width: 60,
			align: 'center',
			render: (value: any, record: CallPassItem, index: number) => record.isBenefit === true
				? <CheckOutlined style={{ color: 'green', fontSize: 18 }} />
				: <CloseOutlined />,
		},
		{
			title: (
				<>
					<div>당일</div>
					<div>수주 수</div>
				</>
			),
			dataIndex: 'duplicateSujuCount',
			key: 'duplicateSujuCount',
			width: 60,
			align: 'center',
		},
		// {
		// 	title: '일정',
		// 	dataIndex: 'schedule',
		// 	key: 'schedule',
		// 	width: 10,
		// 	align: 'center',
		// 	render: (value: any, record: CallPassItem, index: number) => getScheduleStr(record.schedule),
		// },
	];

	return (
		<Table
			bordered
			size='small'
			style={{ tableLayout: 'fixed', width: '100%' }}
			scroll={{ x: 'max-content' }}
			rowHoverable={false}
			pagination={false}
			dataSource={data?.callPassItemList.map((row) => ({...row, key: row.id}))}
			columns={columns}
			rowClassName={(record) => (record.userId === data?.sujuUserId)
				? styles.selected
				: ''
			}
		/>
	);
};

export default TabCallPass;
